import React from 'react'
import { Alert, AlertTitle, Backdrop, Snackbar as MuiSnackbar, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { useNotificationStore } from 'store/useNotificationStore'

const Snackbar = () => {
    const { title, content, show, closeNotification } = useNotificationStore((state) => state)

    return (
        <Backdrop
            sx={{
                backgroundColor: (theme) => theme.palette.common.white[3],
                zIndex: 3000
            }}
            open={show}
        >
            <MuiSnackbar
                role="alertdialog"
                tabIndex={0}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                autoHideDuration={5000}
                open={show}
                onClose={closeNotification}
                sx={{
                    display: 'block',
                    position: 'absolute',
                    '&.MuiSnackbar-anchorOriginTopLeft': {
                        top: 0,
                        left: { xs: 16, md: 72 },
                        right: { xs: 16, md: 72 }
                    }
                }}
            >
                <Alert
                    severity="success"
                    tabIndex={0}
                    icon={<FontAwesomeIcon icon={faCircleCheck} />}
                    onClose={closeNotification}
                    sx={{
                        color: 'text.primary',
                        backgroundColor: 'background.default',
                        border: 'none',
                        borderTop: '10px solid #008200',
                        borderRadius: 1,
                        boxShadow: '0px 4px 10px 2px rgba(0, 0, 0, 0.10)',
                        '.MuiAlert-icon': {
                            padding: '10px 0',
                            marginRight: 4
                        }
                    }}
                >
                    <AlertTitle letterSpacing="1px">
                        <Typography variant="boldBody2" aria-label={title} tabIndex={0}>
                            {title}
                        </Typography>
                        <Typography
                            variant="regularBody2"
                            aria-label={content}
                            aria-describedby="Discloser"
                            tabIndex={0}
                        >
                            {content}
                        </Typography>
                    </AlertTitle>
                </Alert>
            </MuiSnackbar>
        </Backdrop>
    )
}

export default Snackbar
